import {Component, OnInit} from '@angular/core';
import {InfoPageComponent} from '../../shared/components/info-page/info-page.component';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {LangService} from '../../core/services/lang.service';
import {InfoService} from '../../core/api/info.service';
import {
  getInfoLinkCategory,
  getInfoLinkName,
  InfoLink,
  InfoLinks
} from '../../shared/models/info.model';

export interface TopAction {
  name: string;
  phone: string;
  category?: string;
}


@Component({
  selector: 'info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  imports: [InfoPageComponent, CommonModule],
})

export class InfoComponent implements OnInit {

  topActions: TopAction[] = [];

  constructor(private router: Router, private infoService: InfoService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.loadInfoLinks();
  }

  public loadInfoLinks() {
    this.infoService.getInfoLinks().subscribe({
      next: (infoLinks: InfoLinks) => {
        this.topActions = infoLinks.map((infoLink: InfoLink) => ({
          name: getInfoLinkName(infoLink),
          phone: infoLink.phone,
          category: getInfoLinkCategory(infoLink)
        }));
      },
      error: (error) => {
        console.error('Error al obtener info links:', error);
      }
    });
  }

  call(phone: string): void {
    window.location.href = `tel:${phone}`;
  }

  getUniqueCategories(): string[] {
    const categories = new Set(this.topActions.map(action => action.category || ''));
    return Array.from(categories).filter(cat => cat !== '').sort();
  }

  getActionsByCategory(category: string): TopAction[] {
    return this.topActions.filter(action => action.category === category);
  }

}
